export default __webpack_public_path__ + "ad178c0df28bc133be34b982d62f431d.svg";